import { create } from 'zustand'

type NotificationState = 'opened' | 'closed'

type NotificationStore = {
  notificationPaneState: NotificationState
  setNotificationPaneState: (state: NotificationState) => void
  toggleNotificationPane: () => void

  notificationState: NotificationState
  setNotificationState: (state: NotificationState) => void
}

export const useNotificationStore = create<NotificationStore>(set => ({
  notificationPaneState: 'closed',
  setNotificationPaneState: state => set({ notificationPaneState: state }),
  toggleNotificationPane: () =>
    set(prev => ({
      notificationPaneState:
        prev.notificationPaneState === 'opened' ? 'closed' : 'opened'
    })),

  notificationState: 'opened',
  setNotificationState: state => set({ notificationState: state })
}))
